import type { TranscriptSegment } from "@/models/podcast";
import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function assignSpeakersToSegments(segments: TranscriptSegment[]): TranscriptSegment[] {
  return segments.map((s, index) => {
    if (s.speaker) return s;
    return { ...s, speaker: index % 2 === 0 ? "Guide" : "Learner" };
  });
}

export function formatRecordingTime(seconds: number): string {
  const m = Math.floor(seconds / 60);
  const s = Math.floor(seconds % 60);
  return `${m}:${s.toString().padStart(2, "0")}`;
}
